var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { RewardCardContainer, LoadingSkeletonVertical, GenericErrorRefresh, ButtonTrackPerksProgress, ButtonsTrackAndShow, ButtonsTrackAndDetails, ContainerImageText, } from '../../../shared/rewards-hub';
import { InfoPerksContext, RewardsAndOffersContext, DrawerContext, } from '../../../../contexts';
import { rhTierRewards, rhGeneral } from '../../../../constants/RewardsHub';
import { WellDoneTile, NewUnlockedTile, AvailablePerksTile, NoDataStatePerks, } from './PerkTiles';
import { useIsMobile } from '../../../../hooks';
import { PxccMultiplierCard } from '../../../../images/ProXtraCreditCard';
import { getPLCCAccrualData, floorNumberWithCommas } from '../../../Utils';
import { ProgressTracker } from '../../../shared/ProgressTracker';
import { ProgressBarCTA } from './PerkTracker';
var constants = rhTierRewards.perkRewards;
var useCardProps = function () {
    var isChildAccount = React.useContext(RewardsAndOffersContext).isChildAccount;
    return {
        title: isChildAccount ? 'Company Perks' : 'Perks Available',
        faqTitle: 'Perks',
        headerUrl: rhGeneral.faqAnchor,
        dataTestID: 'perksCard',
    };
};
var useGetIsMobile = function () { return useIsMobile().isMobile; };
var useGetIsLoading = function () { return React.useContext(InfoPerksContext).isLoading; };
export var LoadingStatePerks = function () {
    var isMobile = useGetIsMobile();
    var cardProps = useCardProps();
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, cardProps),
        React.createElement(LoadingSkeletonVertical, { isMobile: isMobile })));
};
// Refresh buttons reusable w/ Offers (with parameters)
export var ErrorStatePerks = function () {
    var isMobile = useGetIsMobile();
    var refreshPerks = React.useContext(InfoPerksContext).refreshPerks;
    var cardProps = useCardProps();
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: !useGetIsLoading() });
    var alertPaddingWorkaround = { marginBottom: '-16px' }; // TODO: until Stencil's fixed
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-mb-[-16px]", style: alertPaddingWorkaround },
            React.createElement(GenericErrorRefresh, { refreshFunc: refreshPerks }))));
};
export var RenderWellDone = function () {
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    var isMobile = useGetIsMobile();
    var cardProps = useCardProps();
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: !useGetIsLoading(), itemAmount: 0, FooterButton: isPacDrawersEnabled ? null : ButtonTrackPerksProgress });
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement(WellDoneTile, { isMobile: isMobile })));
};
export var RenderAvailableAndUnlocked = function () {
    var isMobile = useGetIsMobile();
    var _a = React.useContext(InfoPerksContext), perksList = _a.perksList, unclaimedPerksList = _a.unclaimedPerksList, perksActivatedToday = _a.perksActivatedToday;
    var listLimit = isMobile ? 2 : 3;
    // Render Perks Activated Today
    var activatedTodayPerkTileList = perksActivatedToday === null || perksActivatedToday === void 0 ? void 0 : perksActivatedToday.map(function (perk, idx) { return (React.createElement(React.Fragment, { key: "availablePerk-".concat(idx) },
        React.createElement(AvailablePerksTile, { perk: perk, isMobile: isMobile, isFirstTile: idx === 0 }))); });
    // Render Unlocked/Unselected Perks
    var unclaimedPerksTileList = unclaimedPerksList === null || unclaimedPerksList === void 0 ? void 0 : unclaimedPerksList.map(function (perk, idx) { return (React.createElement(React.Fragment, { key: "unlockedPerk-".concat(idx) },
        React.createElement(NewUnlockedTile, { perk: perk, isMobile: isMobile, isFirstTile: !(activatedTodayPerkTileList === null || activatedTodayPerkTileList === void 0 ? void 0 : activatedTodayPerkTileList.length) && idx === 0 }))); });
    // Render Available Perks
    var availablePerkTileList = perksList === null || perksList === void 0 ? void 0 : perksList.map(function (perk, idx) { return (React.createElement(React.Fragment, { key: "availablePerk-".concat(idx) },
        React.createElement(AvailablePerksTile, { perk: perk, isMobile: isMobile, isFirstTile: !unclaimedPerksTileList.length &&
                !(activatedTodayPerkTileList === null || activatedTodayPerkTileList === void 0 ? void 0 : activatedTodayPerkTileList.length) &&
                idx === 0 }))); });
    var unavailablePerk = (perksList === null || perksList === void 0 ? void 0 : perksList.length) === 0 && (React.createElement(React.Fragment, { key: "availablePerk-0" },
        React.createElement(NoDataStatePerks, { isMobile: isMobile })));
    var fullTileList = __spreadArray(__spreadArray(__spreadArray([], activatedTodayPerkTileList, true), unclaimedPerksTileList, true), availablePerkTileList, true);
    var footerButton = null;
    if ((fullTileList === null || fullTileList === void 0 ? void 0 : fullTileList.length) > listLimit) {
        footerButton = ButtonsTrackAndShow;
    }
    var cardProps = useCardProps();
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: !useGetIsLoading(), itemAmount: (fullTileList === null || fullTileList === void 0 ? void 0 : fullTileList.length) || 0, FooterButton: (fullTileList === null || fullTileList === void 0 ? void 0 : fullTileList.length) > 0 ? footerButton : null });
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement("div", { className: "sui-pt-4" }),
        fullTileList.length > 0
            ? fullTileList.slice(0, isMobile ? 2 : 3)
            : unavailablePerk));
};
export var RenderPlcc = function () {
    var isMobile = useGetIsMobile();
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var perkAccrualSummary = (rewardsAndOffers || {}).perkAccrualSummary;
    var activePxccFactor = (perkAccrualSummary || {}).activePxccFactor;
    var spendForNextPerkWithPxcc = getPLCCAccrualData(perkAccrualSummary).spendForNextPerkWithPxcc;
    var amount = floorNumberWithCommas(spendForNextPerkWithPxcc || 0, 0);
    var cardProps = useCardProps();
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: !useGetIsLoading(), itemAmount: 0, FooterButton: ButtonsTrackAndDetails });
    var RenderMultiplierLine = function () { return (React.createElement("span", { className: "sui-font-bold sui-block sui-mb-2 sm:sui-mb-0" }, "".concat(constants.multiplierPxcc(activePxccFactor)))); };
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement(Typography, null, !isMobile && React.createElement(RenderMultiplierLine, null)),
        React.createElement(ContainerImageText, { ImageComponent: PxccMultiplierCard },
            React.createElement(Typography, null,
                isMobile && React.createElement(RenderMultiplierLine, null),
                React.createElement("div", { className: "sui-max-w-[240px] sm:max-md:sui-max-w-[200px]" },
                    React.createElement("span", { className: "sui-font-bold" },
                        "$",
                        amount), "".concat(constants.remainingSpendPxcc)),
                isMobile && React.createElement("div", { className: "sui-h-4" })))));
};
var PerkTrackerForPerkCard = function (_a) {
    var RenderUnlockPerksLine = _a.RenderUnlockPerksLine;
    var isMobile = useGetIsMobile();
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var _b = (rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.perkAccrualSummary) || {}, amtReqToNextLevel = _b.amtReqToNextLevel, perkCurrentTierProgressPercentage = _b.perkCurrentTierProgressPercentage;
    var percentage = perkCurrentTierProgressPercentage || 0;
    var amount = floorNumberWithCommas(amtReqToNextLevel || 0, 0);
    return (React.createElement("div", { className: "md:sui-mt-[-32px]" },
        React.createElement(ContainerImageText, { ImageComponent: function () { return (React.createElement(ProgressTracker, { percentage: percentage || '0' })); } },
            React.createElement(Typography, null,
                isMobile && React.createElement(RenderUnlockPerksLine, null),
                React.createElement("div", { className: "sui-max-w-[240px] sm:max-md:sui-max-w-[200px]" }, constants.remainingSpend("$".concat(amount))),
                !isMobile && React.createElement("span", { className: "sui-h-4 sui-inline-block" })))));
};
export var RenderUntilNextPerk = function () {
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    var isMobile = useGetIsMobile();
    var cardProps = useCardProps();
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: !useGetIsLoading(), itemAmount: 0, FooterButton: isPacDrawersEnabled
            ? ProgressBarCTA
            : ButtonTrackPerksProgress });
    var RenderUnlockPerksLine = function () { return (React.createElement("p", { className: "sui-font-bold sui-block sui-mb-2 sm:sui-mb-0" }, constants.unlockPerks)); };
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement(Typography, null, !isMobile && React.createElement(RenderUnlockPerksLine, null)),
        React.createElement(PerkTrackerForPerkCard, { RenderUnlockPerksLine: RenderUnlockPerksLine })));
};
